import { render } from "./ReportEdit.vue?vue&type=template&id=36d04b1c"
import script from "./ReportEdit.vue?vue&type=script&lang=js"
export * from "./ReportEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__